import {GridColDef} from '@mui/x-data-grid-pro';
import {renderCellDate} from '../../../utils/renderCellDate';
import {renderCellCurrency} from '../../../utils/renderCellCurrency';

export const incomeColumns: GridColDef[] = [
  {
    field: 'contact',
    headerName: 'Owner',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.simplifiedName || '-';
    },
  },
  {
    field: 'incomeDescription',
    headerName: 'Income Description',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'incomeAmount',
    headerName: 'Amount',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    align: 'right',
    renderCell: renderCellCurrency,
  },
  {
    field: 'incomeFrequency',
    headerName: 'Frequency',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'incomeType',
    headerName: 'Income Type',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'incomeSource',
    headerName: 'Income Source',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'taxable',
    headerName: 'Taxable',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    valueFormatter(value) {
      return value ? 'Yes' : 'No';
    },
  },
  {
    field: 'endDate',
    headerName: 'End Date (if known)',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellDate,
  },
];

export const expenditureColumns: GridColDef[] = [
  {
    field: 'contact',
    headerName: 'Owner',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell(params) {
      return params.value?.simplifiedName || '-';
    },
  },
  {
    field: 'expenseDescription',
    headerName: 'Expenditure Description',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'expenseAmount',
    headerName: 'Amount',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    align: 'right',
    renderCell(params) {
      return `£${params.value}`;
    },
  },
  {
    field: 'expenseFrequency',
    headerName: 'Frequency',
    flex: 0.7,
    editable: false,
    headerAlign: 'left',
    sortable: false,
  },
  {
    field: 'endDate',
    headerName: 'Expense End Date (if known)',
    flex: 1,
    editable: false,
    headerAlign: 'left',
    sortable: false,
    renderCell: renderCellDate,
  },
];
